export default "__VITE_ASSET__DHawDLX6__"